module.exports = parcelRequire.resolve("b73Vi");